var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-container"},[_c('div',{staticClass:"help-menu"},[_c('help-menu')],1),_c('div',{staticClass:"help-page"},[_c('help-page')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }